<script>
import { mapActions, mapGetters } from 'vuex'
import PaymentDetails from './payment-details'
import PaymentEdit from './payment-edit'

export default {
  name: 'PaymentSettings',
  page: {
    title: 'Payment Settings',
  },
  components: {
    PaymentDetails,
    PaymentEdit,
  },
  data() {
    return {
      loading: true,
      payment: {},
    }
  },
  computed: {
    ...mapGetters('me', [
      'showSettings',
    ]),
    isEdit() {
      return this.$route.params.edit === 'edit'
    },
    component() {
      return `Payment${this.isEdit ? 'Edit' : 'Details'}`
    },
  },
  async created() {
    // if (!this.showSettings) {
    //   this.$router.replace('/')
    // }

    const [error, data] = await this.getSettings()

    if (!error) {
      this.payment = data
    }

    this.loading = false
  },
  methods: {
    ...mapActions('settings', [
      'getSettings',
    ]),
    onCancel() {
      this.$router.push({
        name: 'payment-settings',
        params: {
          edit: null,
        },
      })
    },
    onEdit(payment) {
      this.payment = payment
      this.onCancel()
    },
  },
}
</script>

<template>
  <main-layout
    title="Payment Settings"
    :loading="loading"
  >
    <payment-details
      v-if="!isEdit"
      :payment="payment"
    />
    <payment-edit
      v-else
      :payment="payment"
      @cancel="onCancel"
      @submit="onEdit"
    />
  </main-layout>
</template>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.button {
  padding-right: rem(100px);
  padding-left: rem(100px);
}
</style>
